/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} StatusInputs */

const en_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const fr_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const de_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const it_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const ru_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const es_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const zh_cn2_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地位`)
};

const ja_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

const hi_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const pt_pt2_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const status = /** @type {((inputs?: StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_status(inputs)
	if (locale === "de") return de_status(inputs)
	if (locale === "it") return it_status(inputs)
	if (locale === "ru") return ru_status(inputs)
	if (locale === "es") return es_status(inputs)
	if (locale === "zh-CN") return zh_cn2_status(inputs)
	if (locale === "ja") return ja_status(inputs)
	if (locale === "hi") return hi_status(inputs)
	if (locale === "pt-PT") return pt_pt2_status(inputs)
	return en_status(inputs)
});